// The commented-out CSS cheat sheet shown in an empty CSS editor. Every
// snippet is wrapped in its own comment block so "uncomment and tweak" is
// one deletion away. A buffer that still equals the scaffold (or is blank)
// is treated as empty at save time — browsing the cheat sheet persists
// nothing. Keep this in lockstep with docs/theming.md — the source of the
// styling contract; customers only ever see THIS scaffold, so no
// customer-visible text may reference repo paths.

const COMMON = `/* Colors and font — the quick knobs the built-in styles read.
.surveys-widget {
    --surveys-bg: #101014;
    --surveys-text: #f4f4f5;
    --surveys-accent: #ff6a00;
    --surveys-font: "Inter", system-ui, sans-serif;
}
*/

/* Make the question larger.
.surveys-prompt {
    font-size: 40px;
}
*/

/* Give the choice buttons more room and a visible border.
.surveys-choice {
    min-width: 120px;
    min-height: 120px;
    border-color: rgba(255, 255, 255, 0.25);
}
*/

/* Restyle the selected chip (it defaults to --surveys-accent above).
.surveys-chip[data-selected="true"] {
    background: #1a7f37;
    border-color: #1a7f37;
}
*/

/* Thank-you screen text.
.surveys-thanks-text {
    font-size: 48px;
}
*/

/* Give inline embeds more breathing room than the compact default.
.surveys-widget[data-mode="inline"] {
    padding: 24px;
}
*/`;

export const TEMPLATE_CSS_SCAFFOLD = `/* ============================================================
   Template CSS — shared by every survey using this template.
   Each block below is commented out: remove the wrapping
   comment markers to activate it, then tweak. Anything you
   leave commented is free.
   ============================================================ */

${COMMON}

/* ------------------------------------------------------------
   Self-hosted brand assets: if you host fonts and images on your
   own domain or CDN, reference them by URL — no upload needed.
   ------------------------------------------------------------ */

/* A brand font from your own server (woff2 recommended).
@font-face {
    font-family: "Brand";
    src: url("https://assets.example.com/brand.woff2") format("woff2");
    font-display: swap;
}
.surveys-widget {
    --surveys-font: "Brand", system-ui, sans-serif;
}
*/

/* A background image from your own server (it is scaled to
   cover the screen and centered automatically).
.surveys-widget {
    background-image: url("https://assets.example.com/backdrop.jpg");
}
*/

/* A logo from your own server: reveal the (empty) logo region
   and paint your image into it. Works when no logo is uploaded.
.surveys-logo[data-empty="true"] {
    display: block;
    width: 20vmin;
    height: 20vmin;
    background: url("https://assets.example.com/logo.svg") center / contain no-repeat;
}
*/
`;

/** True when the buffer would persist nothing: blank, or the untouched scaffold. */
export function isPristineCss(value: string, scaffold: string): boolean {
    const trimmed = value.trim();
    return trimmed === "" || trimmed === scaffold.trim();
}
